import { BUSINESS_FULL_DOC_INCOME_ITEMS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { HelpTooltip } from '../../Common';
import { DollarInputField } from '../../Fields';

interface BusinessFullDocIncomeItemProps extends IncomeEntityIndex {
  businessIncomeIndex: number;
  item: keyof typeof BUSINESS_FULL_DOC_INCOME_ITEMS;
  hasLabel?: boolean;
  isDisabled?: boolean;
  isOptional?: boolean;
  disableFailMessage?: boolean;
}

export const BusinessFullDocIncomeItem = (props: BusinessFullDocIncomeItemProps) => {
  const { incomeIndex, businessIncomeIndex, item, hasLabel = false, ...rest } = props;
  const { label, path, tooltip, allowNegativeValue } = BUSINESS_FULL_DOC_INCOME_ITEMS[item];

  return businessIncomeIndex > -1 ? (
    <DollarInputField
      {...rest}
      isNegativeValueValid={allowNegativeValue}
      isZeroValid
      label={hasLabel ? label : undefined}
      labelAfter={<HelpTooltip content={tooltip} position="left" />}
      name={path(incomeIndex, businessIncomeIndex)}
    />
  ) : null;
};
